import React, { useContext } from 'react';
import { useTransferMode, useTransferActions, useTransferStore } from '#client/stores/transfer/useTransferStore';
import { Page, Button } from '@shopify/polaris';
import { useNavigate } from 'react-router';
import { hasPermission } from '#client/utils/helpers';
import { SessionContext } from '#client/contexts/SessionContext.jsx';

export default function TransferPageWrapper({ children }) {
    // Zustand store hooks
    const { setEditingIndex, handleCancelClick } = useTransferActions();
    const { mode, setMode } = useTransferMode();
    const transferId = useTransferStore.use.transferId();
    const status = useTransferStore.use.status();
    const type = useTransferStore.use.type();
    const locationFromId = useTransferStore.use.locationFromId();
    const locationToId = useTransferStore.use.locationToId();
    const isLoading = useTransferStore.use.isLoading();
    const hasPermissionForActionOnTransfer = useTransferStore.use.hasPermissionForActionOnTransfer();
    const { currentUser } = useContext(SessionContext);

    const navigate = useNavigate();

    const handleChangeMode = (newMode) => {
        setMode(newMode);
        setEditingIndex(null);
        if (newMode === 'create') {
            navigate('/transfers/create', { viewTransition: true });
        } else if (newMode === 'edit') {
            navigate(`/transfers/edit/${transferId}`, { viewTransition: true });
        } else if (newMode === 'receive') {
            navigate(`/transfers/receive/${transferId}`, { viewTransition: true });
        } else {
            navigate(`/transfers/view/${transferId}`, { viewTransition: true });
        }
    };

    let availableActions;
    if (
        mode === 'view' &&
        status !== 'Archived' &&
        status !== 'In Transit' &&
        status !== 'Complete' &&
        status !== 'Exception' &&
        type !== 'Automatic' &&
        status !== 'Canceled' &&
        hasPermission(currentUser, 'transferUpdate') &&
        hasPermissionForActionOnTransfer(locationFromId, currentUser.locationIds)
    ) {
        availableActions = (
            <Button onClick={() => handleChangeMode('edit')} disabled={isLoading}>
                Edit
            </Button>
        );
    } else if (mode === 'view' && status === 'In Transit' && hasPermissionForActionOnTransfer(locationToId, currentUser.locationIds)) {
        availableActions = (
            <Button variant="primary" onClick={() => handleChangeMode('receive')} disabled={isLoading}>
                Receive
            </Button>
        );
    } else {
        availableActions = '';
    }

    let secondaryActions;
    if (mode != 'view') {
        secondaryActions = (
            <Button onClick={() => handleCancelClick(navigate)} disabled={isLoading}>
                Cancel
            </Button>
        );
    }
    return (
        <Page
            title={mode === 'create' ? 'Create New Transfer' : mode === 'edit' ? 'Edit Transfer' : mode === 'view' ? 'View Transfer' : mode === 'receive' ? 'Receive Transfer' : 'Transfer'}
            primaryAction={availableActions}
            secondaryActions={secondaryActions}
            fullWidth
        >
            {children}
        </Page>
    );
}
